module.exports = __webpack_public_path__ + "assets/images/project/icons/icon_360_white.svg?v=4a3f7f1f";